export const LAST_VISITED_URL_KEY = 'LAST_VISITED_URL';
export const SECOND_LAST_VISITED_URL_KEY = 'SECOND_LAST_VISITED_URL';
